import { render, staticRenderFns } from "./StoryCollapse.vue?vue&type=template&id=6194c5ce&scoped=true&"
import script from "./StoryCollapse.vue?vue&type=script&lang=js&"
export * from "./StoryCollapse.vue?vue&type=script&lang=js&"
import style0 from "./StoryCollapse.vue?vue&type=style&index=0&id=6194c5ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6194c5ce",
  null
  
)

export default component.exports